import { z } from 'zod';

/**
 * Sports endpoint Zod schemas for Polymarket Gamma API
 */

export const ListTeamsParamsSchema = z.object({
  limit: z.number().optional(),
  offset: z.number().optional(),
  order: z.string().optional(),
  ascending: z.boolean().optional(),
  league: z.array(z.string()).optional(),
  name: z.array(z.string()).optional(),
  abbreviation: z.array(z.string()).optional(),
});

export const ListSportsMetadataParamsSchema = z.object({
  // The `/sports` endpoint accepts no query parameters
});

export const TeamSchema = z.object({
  id: z.number(),
  name: z.string().nullable().optional(),
  league: z.string().nullable().optional(),
  record: z.string().nullable().optional(),
  logo: z.string().nullable().optional(),
  abbreviation: z.string().nullable().optional(),
  alias: z.string().nullable().optional(),
  createdAt: z.string().nullable().optional(),
  updatedAt: z.string().nullable().optional(),
});

export const ListTeamsRequestSchema = ListTeamsParamsSchema;

export const ListTeamsResponseSchema = z.object({
  data: z.array(TeamSchema),
  total: z.number(),
  limit: z.number(),
  offset: z.number(),
});

export const SportsMetadataSchema = z.object({
  sport: z.string(),
  image: z.string(),
  resolution: z.string(),
  ordering: z.string(),
  tags: z.string(),
  series: z.string(),
});

export const SportsMetadataResponseSchema = z.object({
  data: z.array(SportsMetadataSchema),
});
